export default "__VITE_ASSET__b0e2aa61__"